import { handleActions } from 'redux-actions'
import { TOGGLE_RESUME_NAME_MODAL } from '../actions/modals'
import $ from 'jquery'
import _ from 'underscore'

let defaultState = {
  isOpen: false,
  candidateId: null,
  currentFileName: '',
}

export const renameResumeModal = handleActions(
  {
    [TOGGLE_RESUME_NAME_MODAL]: (state, action) => {
      let nextState = $.extend(true, {}, state)
      const { candidateId, isOpen, currentFileName = '' } = action.payload
      if (isOpen) {
        nextState.isOpen = true
        nextState.candidateId = candidateId
        nextState.currentFileName = currentFileName
      } else {
        nextState = $.extend(true, {}, defaultState)
      }
      return nextState
    },
  },
  defaultState
)
